import React, { useEffect } from 'react';
import { message } from 'antd';
import { Navigate } from 'react-router-dom';
import ProductCard from '../productCard/porductCard';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { IProducts } from '../interfaces';
import Spinner from '../spinner';
import { fetchGuestLikedProduct, fetchLikedProduct } from '../../services';
import PageCollectionHeader from '../pageCollectionHeader';
import CatalogEmptyState from '../catalogEmptyState/CatalogEmptyState';
import './likedProduct.scss';

const LikedProductsList = () => {
  const dispatch = useAppDispatch();

  const { likedProducts, likedProductCountAndIds, status } = useAppSelector((state) => state.likedProduct);
  const userId = useAppSelector((state) => state.user.user?.id);
  const authChecked = useAppSelector((state) => state.user.authChecked);

  const isLoading = !authChecked || status === 'loading' || (status === 'idle' && likedProductCountAndIds.ids.length > 0);
  const isFailed = status === 'failed';
  const isSucceeded = status === 'succeeded';
  const isWishlistUnavailable = isFailed;
  const hasKnownLikedItems =
    likedProducts.length > 0 ||
    likedProductCountAndIds.count > 0 ||
    likedProductCountAndIds.ids.length > 0;
  const shouldRedirectEmptyLiked = authChecked && isSucceeded && !hasKnownLikedItems;

  useEffect(() => {
    if (userId) {
      dispatch(fetchLikedProduct());
    } else if (authChecked) {
      dispatch(fetchGuestLikedProduct());
    }
  }, [authChecked, dispatch, userId]);

  useEffect(() => {
    if (shouldRedirectEmptyLiked) {
      message.warning('Like a product before opening your wishlist.');
    }
  }, [shouldRedirectEmptyLiked]);

  if (shouldRedirectEmptyLiked) {
    return <Navigate to="/products" replace />;
  }

  return (
    <div className="liked-products-wrapper">
      <PageCollectionHeader
        eyebrow="Saved"
        title="Liked Products"
        subtitle="Pieces you marked to revisit later."
      />

      {isLoading ? (
        <Spinner />
      ) : isSucceeded && likedProducts.length > 0 ? (
        <div className="card-container">
          {likedProducts.map((product: IProducts) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      ) : isWishlistUnavailable ? (
        <CatalogEmptyState
          role="alert"
          mark="!"
          eyebrow="Wishlist unavailable"
          title="We can’t load your wishlist right now."
          message="The backend is not responding, so saved products cannot be loaded. Start the backend and refresh this page."
          primaryAction={{ label: 'Refresh wishlist', to: '/product/liked', reloadDocument: true }}
          secondaryAction={{ label: 'View catalog', to: '/products' }}
        />
      ) : null}
    </div>
  );
};

export default LikedProductsList;
